import { CommunityType, RoleID } from "@packages/sdk";

export const getSubjectUserPermissions = ({
  communityType,
  userRole,
}): {
  canEditAndDelete: boolean;
  canPromoteAndDemote: boolean;
  canRemoveFromGroup: boolean;
} => {
  const canEditAndDelete =
    communityType === "school" ||
    (communityType === CommunityType.religious_ed_program &&
      userRole === RoleID.Teacher);
  const canPromoteAndDemote = ![
    CommunityType.school,
    CommunityType.religious_ed_program,
  ].includes(communityType);
  const canRemoveFromGroup = !canEditAndDelete;

  return { canEditAndDelete, canPromoteAndDemote, canRemoveFromGroup };
};
